import React from "react";
import ContactForm from "../../components/forms/ContactForm";
import ContactBanner from "./ContactBanner";

const Contact = () => {
  return (
    <div className="relative">
      <ContactBanner />

      {/* Réclamations Section */}
      <div className="my-5 flex flex-col md:flex-row w-[80%] mx-auto space-y-5 md:space-y-0 md:space-x-8">
        <div className=" mb-5 px-6 py-8 rounded-lg w-full md:w-1/2">
          <h2 className="text-[#0976BC] text-2xl mb-4 flex justify-center">
            Réclamations
          </h2>
          <div className="p-[20px] md:p-[35px] xl:p-[55px] rounded-2xl bg-white drop-shadow-lg border border-gray-400">
            <p className="text-gray-700 mb-4">
              Besoin de précisions sur votre candidature ? La transparence est
              au cœur du processus COPA, toutes les réclamations relatives à la
              sélection des lauréats COPA doivent se faire via l’adresse mail
              dédiée :
              <a
                href="mailto:plaintes@copa.transforme.cd"
                className="text-[#0976BC] underline inline"
              >
                plaintes@copa.transforme.cd
              </a>
            </p>

            {/* Added margin before the next paragraph */}
            <p className="text-gray-700 mb-4 mt-4">
              L’équipe en charge vous répondra dans les plus brefs délais.
            </p>

            <div className="mt-4">
              <a
                href="https://minio-api.dev.addinn-group.com/public-copa-transforme/sub-directory/1750844837167-j3siehol6q.pdf"
                className="text-[#0976BC] text-lg underline"
                target="_blank"
                rel="noopener noreferrer"
              >
                Télécharger le formulaire
              </a>
            </div>
          </div>
        </div>

        {/* Vertical Separator Line */}
        <div className="w-[1px] bg-gray-300 mx-8 my-16"></div>

        {/* Contact Form Section */}
        <div id="contact-form" className="mt-5 mb-5 w-full md:w-1/2 py-8">
          <ContactForm />
        </div>
      </div>
    </div>
  );
};

export default Contact;
